import React from "react";
import * as Updates from "expo-updates";
import {
  Modal,
  Platform,
  View,
  StyleSheet,
  TouchableOpacity,
} from "react-native";
import RText from "../components/RText";
import variables from "../styles/variables";
import LoadingSpinner from "../components/LoadingSpinner";
import Gap from "../components/Gap";

const UseUpdates = (showUpdateModal, setShowUpdateModal) => {
  const [loading, setLoading] = React.useState(false);

  const checkForUpdateAsync = async () => {
    try {
      const update = await Updates.checkForUpdateAsync();

      if (update?.isAvailable && Platform.OS !== "web") {
        setShowUpdateModal(true);
      }
    } catch (error) {
      console.log(`Error checking for updates: ${error}`);
    }
  };

  const onFetchUpdateAsync = async () => {
    try {
      setLoading(true);
      await Updates.fetchUpdateAsync();
      await Updates.reloadAsync();
    } catch (error) {
      console.log(`Error fetching updates: ${error}`);
    } finally {
      setLoading(false);
      setShowUpdateModal(false);
    }
  };

  const updateModel = () => {
    return (
      <Modal
        style={styles.modal}
        animationType="slide"
        transparent={true}
        visible={showUpdateModal}
      >
        {/* overlay */}
        <View style={styles.overlay} />
        <View style={styles.container}>
          <RText
            weight="semiBold"
            size="lg"
            color="white"
            style={{ width: "100%", textAlign: "center" }}
          >
            There's an update available! 🎉
          </RText>
          <Gap vertical size={"small"} />
          <RText weight="semiBold" size="md" color="white">
            To keep using the app, please update now
          </RText>
          <Gap vertical size={"large"} />
          {loading ? (
            <View style={styles.loadingContainer}>
              <LoadingSpinner />
            </View>
          ) : (
            <TouchableOpacity
              onPress={onFetchUpdateAsync}
              style={styles.contentContainer}
            >
              <RText size="md_lg" color="white">
                Update
              </RText>
            </TouchableOpacity>
          )}
        </View>
      </Modal>
    );
  };

  return {
    updateModel,
    checkForUpdateAsync,
  };
};

export default UseUpdates;

const styles = StyleSheet.create({
  modal: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  overlay: {
    height: "100%",
    width: "100%",
    backgroundColor: "black",
    opacity: 0.5,
    justifyContent: "center",
    alignItems: "center",
  },
  container: {
    height: 230,
    width: "90%",
    backgroundColor: variables.colors.palette.rtv.primary,
    borderRadius: 5,
    padding: 20,
    position: "absolute",
    top: "40%",
    alignSelf: "center",
  },
  loadingContainer: {
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 10,
  },
  contentContainer: {
    backgroundColor: variables.colors.palette.rtv.secondary,
    padding: 10,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    marginTop: 10,
  },
});
